// template.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TourService {

    constructor(private http: HttpClient) { }
    getAllFollowups(queryParams: any): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}users/get-all-followups`, { params: queryParams });
    }

    createTour(tourData: any) {
        return this.http.post<any>(`${environment.baseUrl}tours/create-tour`, tourData);
    }

    updateTour(id: string, data: string) {
        return this.http.put<any>(`${environment.baseUrl}tours/update-tour/${id}`, data);
    }

    deleteTour(followupId: string): Observable<any> {
        return this.http.delete<any>(`${environment.baseUrl}users/delete-followup/${followupId}`);
    }

    cancelTour(tourId: string, payload: any) {
        return this.http.patch(`${environment.baseUrl}tours/${tourId}/cancel`, payload);
    }

    getAvailableResidents(plannedDate: string) {
        return this.http.get<any[]>(`${environment.baseUrl}tours/available-residents/${plannedDate}`);
    }

    getAssignedResident(userId: string) {
        return this.http.get<any>(`${environment.baseUrl}tours/assigned-resident/${userId}`);
    }

    rescheduleTour(tourId: string, payload: any) {
        return this.http.post(`${environment.baseUrl}tours/${tourId}/reschedule`, payload);
    }

    getTimeSlot(tourId: string, payload: any) {
        return this.http.post(`${environment.baseUrl}tours/${tourId}/available-times`, payload);
    }

    getPropertyTimeSlot(propertyId: string, weekday: string, date: string) {
        return this.http.get<{ slots: string[] }>(`${environment.baseUrl}availability/${propertyId}/slots/${weekday}`,
            { params: { date } }
        );
    }

    scheduleTour(tourData: any) {
        return this.http.post<any>(`${environment.baseUrl}tours/schedule-tour-from-chatbot`, tourData);
    }
    
    getLeadSources(propertyId: string): Observable<string[]> {
        return this.http.get<string[]>(`${environment.baseUrl}property-yardi/lead-sources`, { params: { propertyId } });
    }

    getPropertyById(propertyId: string): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}properties/property/${propertyId}`);
    }

    getVisibleUnitsByProperty(propertyId: string): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}units/${propertyId}/visible-units`);
    }

    getPropertyDashboard(propertyId: string): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}tours/property/${propertyId}/dashboard`);
    }

    confirmReschedule(tourId: string) {
        return this.http.post(`${environment.baseUrl}tours/${tourId}/confirm-reschedule`, {});
    }

    sendMoreTimes(tourId: string) {
        return this.http.post(`${environment.baseUrl}tours/${tourId}/send-more-times`, {});
    }

    sendTestSms(payload: { to: string; from: string; body: string }) {
        return this.http.post<{ sid: string; status: string }>(`${environment.baseUrl}twilio-conversation/send-test-sms`, payload);
    }

    // 1️⃣ Validate token
    validateSecureToken(token: string): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}secure-links/validate/${token}`);
    }

    // 2️⃣ Consume token (one-time)
    consumeSecureToken(token: string): Observable<any> {
        return this.http.post(`${environment.baseUrl}secure-links/consume`, { token });
    }
}